import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({

  selector: 'generic',
  templateUrl: './popupmodel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls:["./popupmodel.component.scss"]
})
export class PopupModalComponent implements OnInit {

  @Input() type: string;
  @Input() message: string;
  @Output() GenericPopup = new EventEmitter();
  isAlert: boolean = false;
  success: boolean = false;
  public isConfirmed: string = '';
  @Input() isConfirmModal: boolean = false;
  @Input() isAlertSuccess: boolean = false;
  @Input() okButtonCaption: string;
  @Input() cancelButtonCaption: string;

  constructor(public activeModal: NgbActiveModal) {
  }
  confirm() {
    this.isConfirmed = 'confirmed';
    this.isAlert = false;
    this.success = false;
    this.GenericPopup.emit(this.isConfirmed);
    this.activeModal.close();
  }
  ngOnInit() {
    if (this.type === 'success') {
      this.success = true;
    }
    if (this.type === 'warning') {
      this.isAlert = true;
    }
    if (this.type === 'confirm') {
      this.type = 'Confirmation';
    }
    if (this.type === 'alertSuccess') {
      this.isAlertSuccess = true;
    }
  }
}
